<template>
    <div id="app">
        <RouterView v-if="$store.state.dataLoaded !== false" :class="'' + $store.state.client.name + 'Theme'" />
        <Loader :options="loaderOptions" :loadingText="true" :textLight="true" />
    </div>
</template>

<script>
import Loader from '@/Loader.vue';

export default {
    name: 'App',
    components: {
        Loader
    },
    data: function () {
        return {
            loaderOptions: {
                isLoading: true,
                loader: 'dots',
                fullPage: true,
                backgroundColor: '#2f353a',
                color: '#F2F2F2',
                opacity: 1,
                width: 64,
                height: 64
            },
            checkTimeStampInterval: null,
            fetchedData: null
        };
    },
    created: function () {
        if (this.$store.state.dataLoaded) {
            this.setCheckTimeStampInterval();

            this.loaderOptions.isLoading = false;
        } else {
            this.getData();
        }

        this.$router.beforeResolve(this.loadFetchedDataOnRouteLeave);
    },
    methods: {
        setCheckTimeStampInterval: function () {
            var self = this;

            if (this.checkTimeStampInterval) {
                clearInterval(this.checkTimeStampInterval);
            }

            this.checkTimeStampInterval = setInterval(self.checkTimeStamp, 60000); // Every minute
        },
        checkTimeStamp: function () {
            var self = this;

            this.$http.get(window.route + self.$store.state.urls.checkTimeStamp, self.$store.state.getConfig).then(function (response) {
                if (response.body.timeStamp !== self.$store.state.timeStamp) {
                    this.getData(false);
                    return;
                }

                self.loaderOptions.isLoading = false;
            }, function () {
                self.loaderOptions.isLoading = true;
                self.$store.commit('resetState');
                location.reload();
            });
        },
        getDataSuccessCallback(data, load = true) {
            if (!load) {
                this.fetchedData = data;
                return true;
            }

            this.$store.commit('resetState');

            this.$store.commit('set', ['client', data.client]);
            this.$store.commit('set', ['guides', data.guides]);
            this.$store.commit('set', ['timeStamp', data.timeStamp]);
            this.$store.commit('set', ['dataLoaded', true]);

            this.loaderOptions.isLoading = false;

            this.setCheckTimeStampInterval();

            return true;
        },
        getData(load = true) {
            this.$http.get(window.route + this.$store.state.urls.data, this.$store.state.getConfig).then(
                response => this.getDataSuccessCallback(response.body, load)
            );
        },
        async loadFetchedDataOnRouteLeave(to, from, next) {
            if (!this.fetchedData) {
                next();
                return;
            }

            this.$store.commit('set', ['dataLoaded', false]);
            this.getDataSuccessCallback(this.fetchedData);
            console.log('Fetched data loaded successfully');
            this.fetchedData = null;
            next();
        }
    }
};
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
